import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { sciFormatted } from '../../../utils/formatting';
import BlockLabel from './block-label';

const leftAlign = {
  textAlign: 'left',
};

const padding20 = {
  padding: 20,
  height: 150,
};

const AvgLikes = props => {
  const { profile } = props;
  const rawInstagramPosts = _.get(profile, 'rawInstagramPosts', []);

  const postsWithLikes = _.filter(rawInstagramPosts, post => post.likeCount > 0);
  const totalLikes = _.sumBy(postsWithLikes, 'likeCount');

  const postsWithComments = _.filter(rawInstagramPosts, post => post.commentCount > 0);
  const totalComments = _.sumBy(postsWithComments, 'commentCount');

  return (
    <div style={padding20}>
      <h5 style={leftAlign}>
        {_.isEmpty(postsWithLikes) ? '-' : sciFormatted(totalLikes / _.size(postsWithLikes))} Likes
      </h5>
      <h5 style={leftAlign}>
        {_.isEmpty(postsWithComments) ? '-' : sciFormatted(totalComments / _.size(postsWithComments))} Comments
      </h5>
      <BlockLabel label="Avg Engagements" />
    </div>
  );
};

AvgLikes.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default AvgLikes;



// WEBPACK FOOTER //
// ./src/containers/summary/components/avg-likes.js